var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ContentPage',[_c('div',{staticClass:"solo-banner"},[_vm._v("\n    404 Page not found\n  ")])])}
var staticRenderFns = []

export { render, staticRenderFns }